export const Community: any = {
  Discord: "https://discord.gg/YQzvAGkqcg",
  Twitter: "https://twitter.com/HarbergerToken",
  Github: "https://github.com/0xfind",
};

